import { useEventBus } from "@vueuse/core";

export default class Connection {
  constructor(strategy) {
    this.strategy = strategy
    this.isReady = false
  }

  initialize() {
    this.strategy.initialize()
    this.strategy.on('strategy:ready', this.handleReady)
    this.strategy.on('strategy:data', this.handleData)
    this.strategy.on('strategy:error', this.handleError)
    this.strategy.on('strategy:connections', this.handleConnections)
    this.strategy.on('strategy:recording:started', this.handleRecordingStarted)
    this.strategy.on('strategy:recording:stopped', this.handleRecordingStopped)
    this.strategy.on('strategy:failed', this.handleStrategyFailed)
    this.strategy.on('strategy:screensharingStarted:viewer', this.handleViewerScreensharingStarted)
    this.strategy.on('strategy:stream:audio', this.handleAudioStream)
    this.strategy.on('strategy:stream:video', this.handleVideoStream)
    return this
  }

  startScreensharing = async (stream) => {
    await this.strategy.shareScreen(stream)
  }

  stopScreensharing = () => {
    this.strategy.destroyScreensharing()
  }

  startRecording = conference => {
    this.strategy.startRecording(conference)
  }

  stopRecording = () => {
    this.strategy.stopRecording()
  }

  handleReady = event => {
    this.isReady = true
    useEventBus('strategy:ready').emit(event.detail)
  }

  handleData = event => {
    const { type, data } = event.detail;
    const eventBus = useEventBus(type);
    eventBus.emit(data);
  }

  handleVideoStream = event => {
    useEventBus('strategy:stream:video').emit(event.detail)
    useEventBus('strategy:changed').emit()
  }

  handleAudioStream = event => {
    useEventBus('strategy:stream:audio').emit(event.detail)
  }

  handleConnections = event => {
    useEventBus('strategy:connections').emit(event.detail)
  }


  handleViewerScreensharingStarted = event => {
    useEventBus('strategy:screensharingStarted:viewer').emit(event.detail)
  }

  handleRecordingStarted = event => {
    useEventBus('strategy:recording:started').emit(event.detail)
  }

  handleRecordingStopped = event => {
    useEventBus('strategy:recording:stopped').emit(event.detail)
  }

  handleError = event => {
    useEventBus('strategy:error').emit(event.detail)
  }

  broadcast = data => {
    if (this.isReady) {
      this.strategy.broadcast(data)
    }
  }

  async getTotalBits() {
    return await this.strategy.getTotalBits()
  }

  handleStrategyFailed = event => {
    useEventBus('strategy:failed').emit(event.detail)
  }

  destroy = () => {
    this.strategy.off('strategy:ready', this.handleReady)
    this.strategy.off('strategy:data', this.handleData)
    this.strategy.off('strategy:error', this.handleError)
    this.strategy.off('strategy:connections', this.handleConnections)
    this.strategy.off('strategy:recording:started', this.handleRecordingStarted)
    this.strategy.off('strategy:recording:stopped', this.handleRecordingStopped)
    this.strategy.off('strategy:failed', this.handleStrategyFailed)
    this.strategy.off('strategy:screensharingStarted:viewer', this.handleViewerScreensharingStarted)
    this.strategy.off('strategy:stream:audio', this.handleAudioStream)
    this.strategy.off('strategy:stream:video', this.handleVideoStream)
    return this.strategy.destroy()
  }
}
